import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import EmailCapture from '@components/shared/EmailCapture';
import { BodyMDBold, BodyMD } from '@components/shared/TextTypes';
import { useShoppingContext } from './ProductShoppingContext';

interface Props {
  title: string;
  subtitle: string;
  emailListId: string;
}

const PaymentOptionsWaitlist: React.FC<Props> = ({ title, subtitle, emailListId }) => {
  const { t } = useTranslation();
  const { productHeaderData } = useShoppingContext();
  const { textColor, background } = productHeaderData;

  return (
    <WaitlistWrap>
      <BodyMDBold>{t(title)}</BodyMDBold>
      <BodyMD>{t(subtitle)}</BodyMD>
      <EmailCapture id={emailListId} background={background} textColor={textColor} />
    </WaitlistWrap>
  );
};

const WaitlistWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  gap: 15px;
  background: ${Colors.cream};
  border: 1px solid ${Colors.sky};
`;

export default PaymentOptionsWaitlist;
